"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralKey = exports.ReferralType = void 0;
var ReferralType;
(function (ReferralType) {
    ReferralType["Storage"] = "storage";
})(ReferralType = exports.ReferralType || (exports.ReferralType = {}));
var ReferralKey;
(function (ReferralKey) {
    ReferralKey["CreateAccount"] = "create-account";
    ReferralKey["InstallMobileApp"] = "install-mobile-app";
    ReferralKey["ShareFile"] = "share-file";
    ReferralKey["SubscribeToNewsletter"] = "subscribe-to-newsletter";
    ReferralKey["InstallDesktopApp"] = "install-desktop-app";
    ReferralKey["InviteFriends"] = "invite-friends";
})(ReferralKey = exports.ReferralKey || (exports.ReferralKey = {}));
